import React from "react";
import { clone, isEmpty, isNil } from "ramda";
import {
  Autocomplete,
  Button,
  Checkbox,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import palette, { polylineColors } from "../../../../config/colorPalette";
import { ErrorText } from "../styled";
import { handleInterMeasurementTime } from "../utils/utils";
import { ArrowDropDownIcon } from "@mui/x-date-pickers";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";

const ChannelInfo = ({
  equipments,
  setEquipments,
  selectedEquipment,
  setSelectedEquipment,
  assetSensors,
  channelsSensorsIDs,
  setchannelSensorsIDs,
  selectedEquipmentID,
  equipmentInterMeasurement,
  asignedChannelNames,
  chunk,
  channelDataToggle,
  setChannelDataToggle,
  asignedChannelLength,
  asignedChannelsStates,
  setAsignedChannelsStates,
  asignedChannelsInfo,
  setAsignedChannelsInfo,
  asignedChannelMeasurementTime,
  setAsignedChannelMeasurementTime,
  asignedChannelSamplingInterval,
  asignedChannelSpatialResolution,
  setAsignedChannelSpatialResolution,
  setAsignedChannelNames,
  setRealState,
  asignedChannelSubstructures,
  setAsignedChannelSubstructures,
  errors,
  setErrors,
  points,
  asignedChannelSubstructuresToggle,
  setAsignedChannelSubstructuresToggle,
  intl,
}) => {
  const handleClose = (channelDataToggle, setChannelDataToggle, indexChannel) => {
    let newChannel = clone(channelDataToggle);
    if (newChannel[indexChannel]) {
      newChannel[indexChannel] = false;
    } else {
      newChannel[indexChannel] = true;
      for (let indexChannelData = 0; indexChannelData < channelDataToggle.length; indexChannelData++) {
        if (indexChannelData !== indexChannel) {
          newChannel[indexChannelData] = false;
        }
      }
    }
    setChannelDataToggle(newChannel);
  };

  const useStyles = {
    colorSample: {
      width: "20px",
      height: "20px",
      display: "inline-block",
      marginRight: "8px",
      border: "1px solid #ccc",
      borderRadius: "50%",
    },
  };
  return (
    <table style={{ borderCollapse: "collapse", border: "none" }}>
      <tbody>
        {!isNil(asignedChannelNames) &&
          asignedChannelNames.length > 0 &&
          chunk(asignedChannelNames, 10).map((channelGroup, rowIndex) => (
            <tr key={`row-${rowIndex}`} style={{ borderCollapse: "collapse", border: "none" }}>
              {channelGroup.map((channel, groupIndex) => {
                const indexChannel = rowIndex * 10 + groupIndex;

                return (
                  <td td key={`channel-${indexChannel}`} style={{ borderCollapse: "collapse", border: "none" }}>
                    <Button
                      variant="contained"
                      style={{ margin: "5%", backgroundColor: palette.secondary, color: "white" }}
                      onClick={() => {
                        handleClose(channelDataToggle, setChannelDataToggle, indexChannel);
                      }}
                    >
                      {intl.formatMessage({ id: "channel" })} {indexChannel + 1}
                    </Button>
                    <Dialog
                      maxWidth="md"
                      open={channelDataToggle[indexChannel]}
                      onClose={() => handleClose(channelDataToggle, setChannelDataToggle, indexChannel)}
                    >
                      <DialogTitle style={{ fontSize: "x-large", color: palette.primary, fontWeight: "600" }}>
                        {intl.formatMessage({ id: "channel.mayus" })} {indexChannel + 1}
                      </DialogTitle>
                      <DialogContent>
                        <TextField
                          id={`channel_name_${indexChannel}`}
                          style={{ margin: "0.4rem 0.2rem 0.8rem" }}
                          value={asignedChannelNames[indexChannel]}
                          onChange={(e) => {
                            let newNames = clone(asignedChannelNames);
                            newNames[indexChannel] = e.target.value;
                            setAsignedChannelNames(newNames);
                          }}
                          error={errors[`channel_name_${indexChannel}`] ? true : false}
                          variant="outlined"
                          label={intl.formatMessage({ id: "channel.name" })}
                          required
                        ></TextField>
                        {!isNil(asignedChannelSubstructures) && !isNil(asignedChannelSubstructures[indexChannel]) && (
                          <TextField
                            id={`sub_count_${indexChannel}`}
                            style={{ margin: "0.4rem 0.2rem 0.8rem" }}
                            inputProps={{ min: 1 }}
                            defaultValue={asignedChannelSubstructures[indexChannel].length}
                            onChange={(e) => {
                              let newAsignedChannelSubstructures = clone(asignedChannelSubstructures);

                              const newLength = parseInt(e.target.value);
                              const actualLength = asignedChannelSubstructures[indexChannel].length;
                              if (newLength > actualLength) {
                                for (let i = actualLength; i < newLength; i++) {
                                  newAsignedChannelSubstructures[indexChannel].push({
                                    name: "",
                                    type: "inclinometer",
                                    section_count: 1,
                                    polyline: [0, 0],
                                  });
                                }
                              } else {
                                newAsignedChannelSubstructures[indexChannel].splice(newLength);
                              }
                              setAsignedChannelSubstructures(newAsignedChannelSubstructures);
                            }}
                            error={errors[`sub_count_${indexChannel}`] ? true : false}
                            variant="outlined"
                            label={intl.formatMessage({ id: "subs" })}
                            required
                            type="number"
                          ></TextField>
                        )}
                        <TextField
                          id={`channel_length_${indexChannel}`}
                          style={{ margin: "0.4rem 0.2rem 0.8rem" }}
                          inputProps={{ min: 0 }}
                          value={asignedChannelLength[indexChannel]}
                          disabled={true}
                          error={errors[`channel_length_${indexChannel}`] ? true : false}
                          variant="outlined"
                          label={intl.formatMessage({ id: "channel.length" })}
                          type="number"
                          required
                          InputLabelProps={{
                            shrink: true,
                          }}
                        ></TextField>
                        <TextField
                          id={`channel_spatial_resolution_${indexChannel}`}
                          style={{ margin: "0 0.2rem 0.8rem" }}
                          inputProps={{ min: 0 }}
                          value={asignedChannelSpatialResolution[indexChannel]}
                          onChange={(e) => {
                            let newResolutions = clone(asignedChannelSpatialResolution);
                            newResolutions[indexChannel] = parseFloat(e.target.value);
                            setAsignedChannelSpatialResolution(newResolutions);
                          }}
                          error={errors[`channel_spatial_resolution_${indexChannel}`] ? true : false}
                          variant="outlined"
                          label={intl.formatMessage({ id: "channel.spatial.resolution" })}
                          required
                          disabled={
                            selectedEquipment.manufacturer !== "Uptech Sensing" &&
                            selectedEquipment.manufacturer !== "AP Sensing"
                          }
                          type="number"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        ></TextField>
                        <TextField
                          id={`channel_sampling_interval_${indexChannel}`}
                          style={{ margin: "0 0.2rem 0.8rem" }}
                          inputProps={{ min: 0 }}
                          value={asignedChannelSamplingInterval[indexChannel]}
                          disabled={true}
                          error={errors[`channel_sampling_interval_${indexChannel}`] ? true : false}
                          variant="outlined"
                          label={intl.formatMessage({ id: "channel.sampling.interval" })}
                          required
                          type="number"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        ></TextField>
                        <TextField
                          id={`channel_measurement_time_${indexChannel}`}
                          style={{ margin: "0 0.2rem 0.8rem" }}
                          inputProps={{ min: 0 }}
                          value={asignedChannelMeasurementTime[indexChannel]}
                          onChange={(e) => {
                            let newMeasurementTimes = clone(asignedChannelMeasurementTime);
                            newMeasurementTimes[indexChannel] = parseFloat(e.target.value);
                            const newErrors = { ...errors };
                            const actualID = selectedEquipmentID + "_frequency";
                            let newSuma = selectedEquipment.measureFrequency;
                            for (
                              let indexNewMeasurement = 0;
                              indexNewMeasurement < newMeasurementTimes.length;
                              indexNewMeasurement++
                            ) {
                              if (asignedChannelsStates[indexNewMeasurement]) {
                                newSuma = newSuma - newMeasurementTimes[indexNewMeasurement];
                              }
                            }
                            if (
                              isEmpty(newMeasurementTimes[indexChannel]) ||
                              isNaN(newMeasurementTimes[indexChannel])
                            ) {
                              newErrors[e.target.id] = "not.empty";
                            } else if (parseFloat(newMeasurementTimes[indexChannel]) > newSuma) {
                              newErrors[actualID] = "not.higher.than.amount.measurement.time.channels";
                            } else if (parseFloat(newMeasurementTimes[indexChannel]) > 86400) {
                              newErrors[e.target.id] = "not.higher.than.day";
                            } else {
                              delete newErrors[actualID];
                              delete newErrors[e.target.id];
                            }
                            setErrors(newErrors);
                            setAsignedChannelMeasurementTime(newMeasurementTimes);
                          }}
                          error={errors[`channel_measurement_time_${indexChannel}`] ? true : false}
                          variant="outlined"
                          label={intl.formatMessage({ id: "channel.measurement.time" })}
                          required
                          disabled={
                            selectedEquipment.manufacturer !== "Uptech Sensing" &&
                            selectedEquipment.manufacturer !== "AP Sensing"
                          }
                          type="number"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        ></TextField>
                        {!isNil(errors[`channel_measurement_time_${indexChannel}`]) && (
                          <ErrorText>
                            {intl.formatMessage({ id: errors[`channel_measurement_time_${indexChannel}`] })}
                          </ErrorText>
                        )}
                        <FormControlLabel
                          control={
                            <Checkbox
                              id={"checkbox" + indexChannel}
                              sx={{
                                color: palette.primary,
                                "&.Mui-checked": {
                                  color: palette.primary,
                                },
                              }}
                              checked={!asignedChannelsStates[indexChannel]}
                              onChange={(e) => {
                                let newMA = clone(asignedChannelsStates);
                                newMA[indexChannel] = !e.target.checked;
                                setRealState(false);
                                handleInterMeasurementTime({
                                  actualID: selectedEquipmentID + "_frequency",
                                  asignedChannelMeasurementTime,
                                  asignedChannelsStates,
                                  equipmentInterMeasurement,
                                  equipments,
                                  errors,
                                  selectedEquipmentID,
                                  setEquipments,
                                  setErrors,
                                  setSelectedEquipment,
                                  value: null,
                                });
                                setAsignedChannelsStates(newMA);
                              }}
                            />
                          }
                          label={intl.formatMessage({ id: "disable?" })}
                          style={{ marginLeft: "auto" }}
                        />
                        {!asignedChannelsStates[indexChannel] ? (
                          <TextField
                            id={`channel_info_${indexChannel}`}
                            style={{ margin: "0 0.2rem 0.8rem" }}
                            inputProps={{ min: 0 }}
                            value={asignedChannelsInfo[indexChannel]}
                            onChange={(e) => {
                              let newChannelInfo = clone(asignedChannelsInfo);
                              newChannelInfo[indexChannel] = e.target.value;
                              setAsignedChannelsInfo(newChannelInfo);
                            }}
                            error={errors[`channel_info_${indexChannel}`] ? true : false}
                            variant="outlined"
                            label={intl.formatMessage({ id: "channel.info" })}
                          />
                        ) : null}
                        {!isEmpty(assetSensors) && (
                          <Autocomplete
                            multiple
                            id="multiple-checkboxes"
                            options={assetSensors}
                            sx={{ width: "85rem" }}
                            disableCloseOnSelect
                            onChange={(event, values) => {
                              let auxSensors = clone(channelsSensorsIDs);
                              auxSensors[indexChannel] = values;
                              setchannelSensorsIDs(auxSensors);
                            }}
                            getOptionLabel={(option) => option}
                            renderOption={(props, option, { selected }) => (
                              <li {...props}>
                                <Checkbox style={{ marginRight: 8 }} checked={selected} />
                                {intl.formatMessage({ id: option })}
                              </li>
                            )}
                            value={isNil(channelsSensorsIDs[indexChannel]) ? [] : channelsSensorsIDs[indexChannel]}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="outlined"
                                label={intl.formatMessage({ id: "sensor.ids" })}
                              />
                            )}
                          />
                        )}
                        {!isNil(asignedChannelSubstructures) &&
                          !isNil(asignedChannelSubstructures[indexChannel]) &&
                          asignedChannelSubstructures[indexChannel].map((ass, indSub) => (
                            <>
                              <h1
                                style={{ marginRight: "1%" }}
                                id={`sub${indSub}_collapse`}
                                onClick={() => {
                                  let newSub = clone(asignedChannelSubstructuresToggle);
                                  if (newSub[indexChannel][indSub]) {
                                    newSub[indexChannel][indSub] = false;
                                  } else {
                                    newSub[indexChannel][indSub] = true;
                                    for (
                                      let indexChannelData = 0;
                                      indexChannelData < asignedChannelSubstructuresToggle[indexChannel].length;
                                      indexChannelData++
                                    ) {
                                      if (indexChannelData !== indSub) {
                                        newSub[indexChannel][indexChannelData] = false;
                                      }
                                    }
                                  }
                                  setAsignedChannelSubstructuresToggle(newSub);
                                }}
                              >
                                {intl.formatMessage({ id: "sub" })} {indSub + 1}
                                {!asignedChannelSubstructuresToggle[indexChannel][indSub] ? (
                                  <ArrowDropDownIcon />
                                ) : (
                                  <ArrowDropUpIcon />
                                )}
                              </h1>
                              <Collapse in={asignedChannelSubstructuresToggle[indexChannel][indSub]}>
                                <TextField
                                  id={`sub_name_${indSub}`}
                                  style={{ margin: "0.4rem 0.2rem 0.8rem", width: "15rem" }}
                                  defaultValue={ass.name}
                                  onChange={(e) => {
                                    let newAsignedChannelSubstructures = clone(asignedChannelSubstructures);
                                    newAsignedChannelSubstructures[indexChannel][indSub].name = e.target.value;
                                    setAsignedChannelSubstructures(newAsignedChannelSubstructures);
                                  }}
                                  error={errors[`sub_name_${indSub}`] ? true : false}
                                  variant="outlined"
                                  label={intl.formatMessage({ id: "sub.name" })}
                                  required
                                />
                                <TextField
                                  id={`sub_type_${indSub}`}
                                  variant="outlined"
                                  style={{ margin: "0.4rem  0.2rem 0.8rem", width: "15rem" }}
                                  label={intl.formatMessage({ id: "sub.type" })}
                                  value={ass.type}
                                  select
                                  onChange={(e) => {
                                    let newAsignedChannelSubstructures = clone(asignedChannelSubstructures);
                                    newAsignedChannelSubstructures[indexChannel][indSub].type = e.target.value;
                                    const polyNumber = newAsignedChannelSubstructures[indexChannel][indSub].polyline;
                                    if (e.target.value === "generic" && !Number.isInteger(polyNumber)) {
                                      newAsignedChannelSubstructures[indexChannel][indSub].polyline = 0;
                                    } else if (e.target.value === "inclinometer" && Number.isInteger(polyNumber)) {
                                      newAsignedChannelSubstructures[indexChannel][indSub].polyline = [0, 0];
                                    }
                                    setAsignedChannelSubstructures(newAsignedChannelSubstructures);
                                  }}
                                  error={errors[`sub_type_${indSub}`] ? true : false}
                                  required
                                >
                                  {!isNil(points) && !isEmpty(points.points) && (
                                    <MenuItem key={`sub_type_${indSub}_generic`} value={"generic"}>
                                      Generic
                                    </MenuItem>
                                  )}
                                  <MenuItem key={`sub_type_${indSub}_inclinometer`} value={"inclinometer"}>
                                    Inclinometer
                                  </MenuItem>
                                </TextField>
                                <TextField
                                  id={`sub_sectioncount_${indSub}`}
                                  style={{ margin: "0.4rem 0.2rem 0.8rem", width: "15rem" }}
                                  defaultValue={ass.section_count}
                                  inputProps={{ min: 1 }}
                                  onChange={(e) => {
                                    let newAsignedChannelSubstructures = clone(asignedChannelSubstructures);
                                    newAsignedChannelSubstructures[indexChannel][indSub].section_count = parseInt(
                                      e.target.value,
                                    );
                                    setAsignedChannelSubstructures(newAsignedChannelSubstructures);
                                  }}
                                  type="number"
                                  error={errors[`sub_sectioncount_${indSub}`] ? true : false}
                                  variant="outlined"
                                  label={intl.formatMessage({ id: "sub.section" })}
                                  required
                                ></TextField>
                                <div style={{ margin: "0.4rem 0.2rem 0.8rem", display: "inline-block" }}>
                                  {ass.type === "generic" ? (
                                    <Select
                                      id={selectedEquipmentID + "channel" + indexChannel}
                                      label={intl.formatMessage({ id: "sub.polyline" })}
                                      onChange={(e) => {
                                        let newAsignedChannelSubstructures = clone(asignedChannelSubstructures);
                                        newAsignedChannelSubstructures[indexChannel][indSub].polyline = parseInt(
                                          e.target.value,
                                        );
                                        setAsignedChannelSubstructures(newAsignedChannelSubstructures);
                                      }}
                                      defaultValue={ass.polyline}
                                    >
                                      {!isNil(points) &&
                                        points.points.map((p, indPoly) => {
                                          return (
                                            <MenuItem
                                              key={selectedEquipmentID + "channel" + indexChannel + "_" + indPoly}
                                              value={indPoly}
                                            >
                                              <div
                                                className={useStyles.colorSample}
                                                style={{
                                                  backgroundColor: polylineColors[indPoly],
                                                  width: "20px",
                                                  height: "20px",
                                                  display: "inline-block",
                                                  marginRight: "8px",
                                                  border: "1px solid #ccc",
                                                }}
                                              ></div>
                                            </MenuItem>
                                          );
                                        })}
                                    </Select>
                                  ) : (
                                    <div style={{ display: "inline" }}>
                                      <TextField
                                        id={`sub_lat_${indSub}`}
                                        style={{ margin: "0.4rem 0.2rem 0.8rem", width: "6.5rem" }}
                                        defaultValue={ass.polyline[0]}
                                        inputProps={{ min: -180, max: 180 }}
                                        onChange={(e) => {
                                          let newAsignedChannelSubstructures = clone(asignedChannelSubstructures);
                                          if (!Number.isNaN(parseFloat(e.target.value)) && !isNil(e.target.value)) {
                                            newAsignedChannelSubstructures[indexChannel][indSub].polyline[0] =
                                              parseFloat(e.target.value);
                                          }
                                          setAsignedChannelSubstructures(newAsignedChannelSubstructures);
                                        }}
                                        type="number"
                                        error={errors[`sub_lat_${indSub}`] ? true : false}
                                        variant="outlined"
                                        label={intl.formatMessage({ id: "latitude" })}
                                        required
                                      ></TextField>
                                      <TextField
                                        id={`sub_lon_${indSub}`}
                                        style={{ margin: "0.4rem 0.2rem 0.8rem", width: "6.5rem" }}
                                        defaultValue={ass.polyline[1]}
                                        inputProps={{ min: -180, max: 180 }}
                                        onChange={(e) => {
                                          let newAsignedChannelSubstructures = clone(asignedChannelSubstructures);

                                          if (!Number.isNaN(parseFloat(e.target.value)) && !isNil(e.target.value)) {
                                            newAsignedChannelSubstructures[indexChannel][indSub].polyline[1] =
                                              parseFloat(e.target.value);
                                          }
                                          setAsignedChannelSubstructures(newAsignedChannelSubstructures);
                                        }}
                                        type="number"
                                        error={errors[`sub_lon_${indSub}`] ? true : false}
                                        variant="outlined"
                                        label={intl.formatMessage({ id: "longitude" })}
                                        required
                                      ></TextField>
                                    </div>
                                  )}
                                </div>
                              </Collapse>
                            </>
                          ))}
                      </DialogContent>
                      <DialogActions>
                        <Button
                          variant="contained"
                          style={{ backgroundColor: palette.secondary, color: "white" }}
                          onClick={() => handleClose(channelDataToggle, setChannelDataToggle, indexChannel)}
                        >
                          {intl.formatMessage({ id: "accept" })}
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </td>
                );
              })}
            </tr>
          ))}
      </tbody>
    </table>
  );
};

export default ChannelInfo;
